import axios from "axios"
import * as allActions from "../../actions/actions.constants"
import * as ForgotpassAction from "../../actions/Forgotpassword/ForgotpassAction"

const ForgotpasswordService = (store) => next => action => {
    const url = process.env.REACT_APP_SERVICES_API;
    next(action)
    switch (action.type) {
        case allActions.FETCH_NEW_FORGOT_PASS:
            axios.request({
                url: `${url}jsonindex/user-password?emailId=${action.payload}`,
                method: "POST"
            })
                .then((response) => {
                    next(ForgotpassAction.reciveNewForgotpass(response.data))
                })
                .catch((error) => {
                    console.log(error);
                })
            break;

        default: break;
    }
}
export default ForgotpasswordService